import { FC } from 'react';

type Props = {
	className?: string;
};

const PackageIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M2.74219 5.90701V13.8413C2.74219 14.6751 3.35047 15.2297 4.09914 15.6789C4.85704 16.1337 6.12914 16.6711 7.53802 17.2662C8.59411 17.7127 9.27492 18.0005 9.9983 18.0005C10.7217 18.0005 11.4025 17.7127 12.4585 17.2663C13.8673 16.6712 15.1396 16.1337 15.8975 15.6789C16.6462 15.2297 17.2544 14.6751 17.2544 13.8413V5.90701C17.2544 5.76535 17.2016 5.63602 17.1147 5.5376L14.6635 6.72768L12.4895 7.77965C11.0994 8.4523 10.5621 8.69782 9.9983 8.69782C9.43448 8.69782 8.89716 8.4523 7.50711 7.77965L5.3331 6.72768L2.88191 5.5376C2.79496 5.63602 2.74219 5.76535 2.74219 5.90701ZM5.78274 9.5009C5.50702 9.363 5.17175 9.47478 5.03388 9.75051C4.89602 10.0262 5.00778 10.3615 5.2835 10.4993L6.77193 11.2436C7.04766 11.3815 7.38293 11.2697 7.52079 10.9939C7.65865 10.7182 7.5469 10.3829 7.27117 10.2451L5.78274 9.5009Z'
				fill='inherit'
				stroke='transparent'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M9.9983 2C9.12571 2 8.32791 2.37843 7.16349 2.93076L4.84741 4.02803C4.30803 4.28349 3.83246 4.50874 3.49787 4.73C3.16287 4.95153 2.74219 5.31489 2.74219 5.90714C2.74219 6.49939 3.16287 6.86274 3.49787 7.08427C3.83246 7.30553 4.30803 7.53077 4.8474 7.78624L7.1635 8.88355C8.32791 9.43583 9.12571 9.81427 9.9983 9.81427C10.8709 9.81427 11.6687 9.43583 12.8331 8.88355L15.1492 7.78625C15.6886 7.53079 16.1641 7.30554 16.4987 7.08427C16.8337 6.86274 17.2544 6.49939 17.2544 5.90714C17.2544 5.31489 16.8337 4.95153 16.4987 4.73C16.1641 4.50874 15.6886 4.28349 15.1492 4.02802L12.8331 2.93076C11.6687 2.37843 10.8709 2 9.9983 2ZM7.64846 4.28027C9.01951 3.63076 9.49997 3.42157 9.99837 3.42157C10.4546 3.42157 10.8958 3.59685 12.0188 4.12469L6.32834 6.9102L5.5288 6.53143C4.92547 6.24562 4.54749 6.06454 4.31056 5.90793C4.54749 5.75132 4.92547 5.57025 5.5288 5.28443L7.64846 4.28027ZM7.97796 7.69117L13.6684 4.90566L14.4679 5.28443C15.0713 5.57025 15.4492 5.75132 15.6861 5.90793C15.4492 6.06454 15.0713 6.24562 14.4679 6.53143L12.3482 7.5356C10.9772 8.1851 10.4968 8.39429 9.99837 8.39429C9.5421 8.39429 9.10092 8.21901 7.97796 7.69117Z'
				fill='inherit'
				stroke='transparent'
			/>
		</svg>
	);
};

export default PackageIconSolid;
